// Spiegazione di una funzione AI con lo stesso schema in tutta la pagina
// Routing AI: "Come funziona" richiudibile con Cosa fa, Quando interviene,
// Impatto e costi, Consiglio, Nota. Le voci assenti non vengono mostrate.
import { Info } from 'lucide-react';

export interface FunctionHelpContent {
  whatItDoes: string;
  /** Voci di dettaglio sotto "Cosa fa" (es. le tecniche di RAG Plus). */
  points?: ReadonlyArray<{ label: string; text: string }>;
  whenItRuns?: string;
  impact?: string;
  advice?: string;
  notes?: string;
}

interface FunctionHelpProps {
  content: FunctionHelpContent;
  testId?: string;
  label?: string;
}

const ROWS: ReadonlyArray<{ key: 'whenItRuns' | 'impact' | 'advice'; title: string }> = [
  { key: 'whenItRuns', title: 'Quando interviene' },
  { key: 'impact', title: 'Impatto e costi' },
  { key: 'advice', title: 'Consiglio' },
];

export default function FunctionHelp({ content, testId, label = 'Come funziona' }: FunctionHelpProps) {
  return (
    <details className="group mt-1.5" data-testid={testId}>
      <summary className="inline-flex cursor-pointer select-none list-none items-center gap-1 rounded text-[11px] font-medium text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <Info className="h-3 w-3" aria-hidden="true" />
        {label}
        <span className="inline-block transition-transform group-open:rotate-90" aria-hidden="true">▸</span>
      </summary>
      <dl className="mt-2 space-y-2 rounded-md border bg-muted/40 p-3 text-xs">
        <div>
          <dt className="font-semibold text-foreground">Cosa fa</dt>
          <dd className="mt-0.5 leading-relaxed text-muted-foreground">{content.whatItDoes}</dd>
          {content.points && content.points.length > 0 && (
            <dd className="mt-1">
              <ul className="ml-4 list-disc space-y-0.5 text-muted-foreground">
                {content.points.map((p) => (
                  <li key={p.label}><strong className="text-foreground">{p.label}</strong>: {p.text}</li>
                ))}
              </ul>
            </dd>
          )}
        </div>
        {ROWS.map(({ key, title }) => {
          const text = content[key];
          if (!text) return null;
          return (
            <div key={key}>
              <dt className="font-semibold text-foreground">{title}</dt>
              <dd className="mt-0.5 whitespace-pre-line leading-relaxed text-muted-foreground">{text}</dd>
            </div>
          );
        })}
        {content.notes && (
          <div className="rounded border border-amber-500/30 bg-amber-500/10 p-2">
            <dt className="font-semibold text-amber-800 dark:text-amber-300">Nota</dt>
            <dd className="mt-0.5 leading-relaxed text-amber-800 dark:text-amber-300">{content.notes}</dd>
          </div>
        )}
      </dl>
    </details>
  );
}
